// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2689":"31d51a633384536e","8330":"bbdf2c53d0fadcf9"}[chunkId] + ".js";
};